import React, { useContext } from "react";

import TRow from "./TRow";

import TableContext from "./TContext";

const TBody = () => {
  const { notesV2, setNotesV2 } = useContext(TableContext);

  return (
    <>
      {notesV2.map((doc) => (
        <TRow key={doc._id || doc.id} doc={doc} />
      ))}
    </>
  );
};

export default TBody;
